import { RoleAccessSettings, EntityPermissionNode } from '../../../models/roles';

export class LookupsPermissionHelper {
    static hasUserAccessToAnyLookup(accesses: RoleAccessSettings) {
        return Object.keys(accesses.lookups).map(x => accesses.lookups[x] as EntityPermissionNode).some(x => x.canRead);
    }
}